import React, { useState } from "react";
import EventsFilter from "./EventsFilter";
import EventsResults from "./EventsResults";
import { EventsService } from "../services/EventsService";
import {
  EventFilterRequest,
  EventResponseDto,
} from "../services/Dtos/EventsDtos";
import showToast from "../helpers/notification";

const Analytics: React.FC = () => {
  const [events, setEvents] = useState<EventResponseDto[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [hasSearched, setHasSearched] = useState<boolean>(false);

  const handleFilter = async (filters: EventFilterRequest) => {
    setLoading(true);
    setError(null);
    setHasSearched(true);

    try {
      const response = await EventsService.events.filter(filters);

      if (response.success) {
        setEvents(response.data || []);
        // showToast("success", `Successfully loaded ${response.data?.length || 0} event(s)`);
      } else {
        setError(response.message || "Failed to fetch events");
        showToast("error", response.message || "Failed to fetch events");
      }
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "An error occurred while fetching events. Please try again.";
      setError(errorMessage);
      showToast("error", errorMessage);
      console.error("Filter error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="mb-4">
        <h1 className="text-primary fw-bold">Analytics</h1>
        <p className="text-muted">
          Filter and analyze delivery events across your organization
        </p>
      </div>

      {/* Filter Section */}
      <EventsFilter onFilter={handleFilter} loading={loading} />

      {/* Error Display */}
      {error && (
        <div className="alert alert-danger alert-dismissible fade show mb-3" role="alert">
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
            aria-label="Close"
          ></button>
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <div className="d-flex justify-content-center align-items-center py-5">
          <div className="spinner-border text-primary me-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mb-0">Fetching events...</p>
        </div>
      )}

      {/* Results Section */}
      {!loading && hasSearched && (
        <EventsResults events={events} loading={loading} />
      )}

      {/* Initial State - No search performed yet */}
      {!loading && !hasSearched && (
        <div className="d-flex justify-content-center align-items-center py-5" style={{ minHeight: "200px" }}>
          <div className="text-center text-muted">
            <p className="mb-2">Use the filters above to search for events.</p>
            <p className="mb-0">If no date range is specified, the last 7 days will be searched by default.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Analytics;
